import React from 'react'
import { Container } from 'react-responsive-grid'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Headroom from 'react-headroom'
import '../css/markdown-styles'

import { rhythm } from '../utils/typography'


module.exports = React.createClass({


    propTypes () {
        return {
            children: React.PropTypes.any,
        }
    },
    render () {
        return (
            <div>
                <Headroom
                    wrapperStyle={{
                        marginBottom: rhythm(1),
                    }}
                    style={{
                        background: '#1244ee',
                    }}>
                    <Container
                        style={{
                            maxWidth: '40rem',
                            paddingTop: 0,
                            padding: `${rhythm(1/2)} ${rhythm(3/4)}`,
                        }}>
                        <Link
                            to={prefixLink('/')}
                            to={prefixLink('/')}
                            style={{
                                color: 'black',
                                textDecoration: 'none',
                            }}
                        >
                            <h2 style={{ float: 'left'}}>Badness 10.000</h2>
                            <a className="twitter-bird" href="//www.twitter.com/ali_pang" style={{float: 'right'}}>
                                <img src="https://g.twimg.com/dev/documentation/image/Twitter_logo_blue_48.png" style={{ margin: '0', filter: 'brightness(4)', maxHeight: '2.1rem' }}/>
                            </a>

                        </Link>
                    </Container>
                </Headroom>
                <Container
                    style={{
                        maxWidth: '40rem',
                        padding: `${rhythm(1)} ${rhythm(3/4)}`,
                        paddingTop: 0,
                    }}>
                    {this.props.children}
                </Container>
            </div>
        )
    },
})



// WEBPACK FOOTER //
// ./_template.jsx